import styles from './index.module.css'

import React from 'react'
type Props = {
  children: React.ReactNode
}

const FlexContent = ({ children }: Props): React.ReactElement<'div'> => (
  <div className={styles.content}>{children}</div>
)

export default FlexContent
